import React from "react";
import { DateInput, Edit, SimpleForm, TextInput } from "react-admin";

export const InvitationEdit = (props) => (
  <Edit {...props}>
    <SimpleForm>
      <TextInput source="id" />
      <TextInput source="uuid" />
      <TextInput source="invitationCode" />
      <TextInput source="invitationType" />
      <TextInput source="receiverEmailAdress" />
      <TextInput source="deliveryStatus" />
      <TextInput source="lastSuccesfulDeliveryAt" />
      <TextInput source="subject" />
      <TextInput source="personalSalutation" />
      <TextInput source="personalMessage" />
      <TextInput source="personalSignature" />
      <DateInput source="createdAt" />
      <DateInput source="updatedAt" />
    </SimpleForm>
  </Edit>
);
